import { jsx as _jsx } from "react/jsx-runtime";
export function TableHeader({ children }) {
    return (_jsx("thead", { className: "text-xs sticky top-0 z-10 bg-neutral-50", children: children }));
}
